import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgBell(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M17.25 3.83054C21.9684 4.44331 25.6126 8.47787 25.6126 13.363V16.1765C25.6126 17.8046 26.2019 19.834 26.8501 21.5442C27.1672 22.3806 27.4848 23.1062 27.7229 23.6221C27.8417 23.8797 27.9402 24.0837 28.0082 24.2219C28.0422 24.291 28.0685 24.3435 28.0859 24.378L28.1052 24.4158L28.1094 24.4241L28.11 24.4252C28.3105 24.8126 28.2947 25.2769 28.068 25.6496C27.8412 26.0224 27.4364 26.25 27 26.25H21.1003C20.5395 28.546 18.4687 30.25 16 30.25C13.5313 30.25 11.4605 28.546 10.8997 26.25H5C4.56362 26.25 4.15883 26.0224 3.93205 25.6496C3.70534 25.2769 3.68935 24.813 3.88983 24.4255L3.89057 24.4241L3.89484 24.4158L3.91406 24.378C3.93146 24.3435 3.95779 24.291 3.99178 24.2219C4.05979 24.0837 4.1583 23.8796 4.27714 23.6221C4.51524 23.1062 4.83284 22.3806 5.14986 21.5442C5.79808 19.834 6.38743 17.8046 6.38743 16.1765V13.363C6.38743 8.47787 10.0316 4.44331 14.75 3.83054V2H17.25V3.83054ZM16 27.75C14.9313 27.75 14.005 27.1404 13.5499 26.25H18.4501C17.995 27.1404 17.0687 27.75 16 27.75ZM6.95543 23.75H25.0446C24.8758 23.3549 24.6942 22.9098 24.5124 22.4303C23.8419 20.6613 23.1126 18.279 23.1126 16.1765V13.363C23.1126 9.43478 19.9281 6.25 16 6.25C12.0719 6.25 8.88743 9.43479 8.88743 13.363V16.1765C8.88743 18.279 8.15806 20.6613 7.48757 22.4303C7.30579 22.9098 7.12419 23.3549 6.95543 23.75Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgBell);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
